import Cookies from 'js-cookie';

export const storage = {
  getItem(key: string, defaultValue?: string) {
    try {
      const cookieValue = Cookies.get(key);
      if (cookieValue !== undefined) {
        return deserialize(cookieValue);
      }
    } catch (e) {
      console.error(`Error getting cookie for key "${key}":`, e);
    }

    try {
      const storageValue = localStorage.getItem(key);
      if (storageValue !== null) {
        return deserialize(storageValue);
      }
    } catch (e) {
      console.error(`Error getting localStorage for key "${key}":`, e);
    }

    return defaultValue;
  },

  setItem(key: string, value: string) {
    try {
      Cookies.set(key, serialize(value));
    } catch (cookieError) {
      console.error(`Error setting cookie for key "${key}":`, cookieError);
      try {
        localStorage.setItem(key, serialize(value));
      } catch (storageError) {
        console.error(`Error setting localStorage for key "${key}":`, storageError);
      }
    }
  },

  removeItem(key: string) {
    try {
      Cookies.remove(key);
    } catch (cookieError) {
      console.error(`Error removing cookie for key "${key}":`, cookieError);
    }
    try {
      localStorage.removeItem(key);
    } catch (storageError) {
      console.error(`Error removing localStorage for key "${key}":`, storageError);
    }
  },
};

function serialize<T>(value: T) {
  try {
    return JSON.stringify(value);
  } catch (error) {
    throw new Error(`Failed to serialize the value`);
  }
}

function deserialize(value: string) {
  try {
    return JSON.parse(value);
  } catch {
    return value;
  }
}
